import {CONSONANT_VOWEL_PAIRS_SS} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_ss";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_SS_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_SS} title="Consonant-Vowel Pairs: ㅆ (ss)" />
     </>
);}